<div class="flex flex-col flex-auto min-w-0">

    <!-- Header -->
    <div
        class="flex flex-col sm:flex-row flex-0 sm:items-center sm:justify-between p-6 sm:py-8 sm:px-10 border-b bg-card dark:bg-transparent">
        <div class="flex-1 min-w-0">
            <!-- Breadcrumbs -->
            <div class="flex flex-wrap items-center font-medium">
                <div>
                    <a class="whitespace-nowrap text-primary-500"
                        [routerLink]="['/s', profile.store.online_name]">Profile</a>
                </div>
                <div class="flex items-center ml-1 whitespace-nowrap">
                    <mat-icon class="icon-size-5 text-secondary" [svgIcon]="'heroicons_solid:chevron-right'"></mat-icon>
                    <a class="ml-1 text-primary-500">Quotation</a>
                </div>
            </div>
            <!-- Title -->
            <div class="mt-2">
                <h2 class="text-3xl md:text-4xl font-extrabold tracking-tight leading-7 sm:leading-10 truncate">
                    Price Quote Form
                </h2>
            </div>
        </div>
    </div>

    <!-- Main -->
    <div class="flex-auto p-6 sm:p-10">

        <div class="max-w-3xl">

            <div class="prose prose-sm max-w-3xl">
                <p>
                    If you wish to speak with us directly you can reach us at <a href="tel:+16473905455">+1(647)390-5455</a> and we will be happy to help you.

                    <!-- <a
                                class="link"
                                href="https://material.angular.io/components/stepper/overview"
                                rel="noreferrer"
                                target="_blank">https://material.angular.io/components/stepper/overview
                            </a> -->

                </p>
                <!-- <p>
                           
                           Remember to keep all your project related conversations and transactions with <b>ESEEL</b>. Your
                           payments will only be released upon your request.
                        </p> -->
            </div>

            <!-- Horizontal stepper -->
            <div class="mt-16 mb-8 text-3xl font-bold">
                <!-- Quotation Form -->
            </div>

            <form class="p-4 bg-card shadow rounded overflow-hidden" [formGroup]="quoteStepperForm">
                <mat-vertical-stepper [linear]="true" #horizontalStepper>
                    <mat-step [formGroupName]="'step1'" [stepControl]="quoteStepperForm.get('step1')"
                        [editable]="isEditable" #horizontalStepperStep1>
                        <ng-template matStepLabel>Project information</ng-template>
                        <p class="my-6 font-medium">
                            Fill in your project information, what needs to be done?
                        </p>
                        <div class="flex">
                            <mat-form-field class="fuse-mat-textarea flex-auto">
                                <textarea matInput [formControlName]="'description'" [placeholder]="'Project info'"
                                    [rows]="10"></textarea>
                                <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:menu-alt-2'">
                                </mat-icon>
                                <mat-error *ngIf="description.touched && description.hasError('required')">
                                    Project info is required.
                                </mat-error>
                                <mat-error *ngIf="description.touched && description.hasError('maxlength')">
                                    Max 3000 characters.
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="flex justify-end">
                            <button class="px-8" mat-flat-button [color]="'primary'"
                                [disabled]="horizontalStepperStep1.stepControl.pristine || horizontalStepperStep1.stepControl.invalid"
                                type="button" (click)="gtagEvent('step1')" matStepperNext>
                                Next
                            </button>
                        </div>
                    </mat-step>

                    <mat-step [formGroupName]="'step2'" [stepControl]="quoteStepperForm.get('step2')"
                        [editable]="isEditable" #horizontalStepperStep2>
                        <ng-template matStepLabel>Profile</ng-template>
                        <p class="my-6 font-medium">
                            Your information
                        </p>
                        <div class="flex">
                            <mat-form-field class="flex-auto">
                                <input matInput [formControlName]="'email'" [placeholder]="'Email Address'"  required>
                                <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:mail'"></mat-icon>
                                <mat-error *ngIf="email.touched && email.hasError('email')">
                                    Must be a valid email.
                                </mat-error>
                                <mat-error *ngIf="email.touched && email.hasError('required')">
                                    Email is required.
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="flex">
                            <mat-form-field class="flex-auto">
                                <input matInput [formControlName]="'phonenumber'" [placeholder]="'Phone number'">
                                <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:phone'"></mat-icon>

                            </mat-form-field>
                        </div>
                        <div class="flex">
                            <mat-form-field class="flex-auto">
                                <input matInput [formControlName]="'company_name'" [placeholder]="'Company name'">
                                <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:office-building'">
                                </mat-icon>

                            </mat-form-field>
                        </div>
                        <div class="flex flex-col gt-xs:flex-row">
                            <mat-form-field class="flex-auto gt-xs:pr-3">
                                <input matInput [formControlName]="'first_name'" [placeholder]="'First name'" required>
                                <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:user-circle'">
                                </mat-icon>
                                <mat-error *ngIf="first_name.touched && first_name.hasError('required')">
                                    First name is required.
                                </mat-error>
                            </mat-form-field>
                            <mat-form-field class="flex-auto gt-xs:pl-3">
                                <input matInput [formControlName]="'last_name'" [placeholder]="'Last name'" required>
                                <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:user-circle'">
                                </mat-icon>
                                <mat-error *ngIf="last_name.touched && last_name.hasError('required')">
                                    Last name is required.
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <!-- <div class="flex flex-col gt-sm:flex-row">
                            <div class="flex flex-col">
                                <span class="font-medium mb-2">An account will help you organize and followup with all
                                    your projects.</span>
                                <div class="flex flex-col">
                                    <mat-checkbox class="mb-1" [color]="'primary'" [formControlName]="'account'" #accountField>
                                        Create an account ?
                                    </mat-checkbox>
                                </div>
                            </div>
                        </div> -->
                        <!-- <div class="flex" hidden="accountField.checked" >
                            <mat-form-field class="flex-auto">
                                <input matInput type="password"  [formControlName]="'password'" [placeholder]="'Password'" #passwordField required>
                                <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:key'"></mat-icon>
                                <button
                                    mat-icon-button
                                    type="button"
                                    (click)="passwordField.type === 'password' ? passwordField.type = 'text' : passwordField.type = 'password'"
                                    matSuffix>
                                    <mat-icon
                                        class="icon-size-5"
                                        *ngIf="passwordField.type === 'password'"
                                        [svgIcon]="'heroicons_solid:eye'"></mat-icon>
                                    <mat-icon
                                        class="icon-size-5"
                                        *ngIf="passwordField.type === 'text'"
                                        [svgIcon]="'heroicons_solid:eye-off'"></mat-icon>
                                </button>
                            </mat-form-field>
                        </div> -->

                        <div class="flex justify-end">
                            <button class="px-8 mr-2" mat-flat-button [color]="'accent'" type="button"
                                (click)="gtagEvent('back_step1')" matStepperPrevious>
                                Back
                            </button>
                            <button class="px-8" mat-flat-button [color]="'primary'"
                                [disabled]="horizontalStepperStep2.stepControl.pristine || horizontalStepperStep2.stepControl.invalid"
                                type="button" (click)="gtagEvent('step2')" matStepperNext>
                                Next
                            </button>
                        </div>
                    </mat-step>

                    <mat-step [formGroupName]="'step3'" [stepControl]="quoteStepperForm.get('step3')"
                        [editable]="isEditable">
                        <ng-template matStepLabel>Location</ng-template>
                        <p class="my-6 font-medium">
                            Select your address from the dropdown menu.
                        </p>
                        <div class="flex">
                            <mat-form-field class="flex-auto">
                                <input matInput [formControlName]="'address'" [placeholder]="'Address'"
                                    autocorrect="off" autocapitalize="off" spellcheck="off" type="text"
                                    autocomplete="new-password" #search>
                                <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:location-marker'">
                                </mat-icon>
                                <mat-error *ngIf="address.touched && address.hasError('required')">
                                    Address is required.
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="flex">
                            <mat-form-field class="flex-auto">
                                <input matInput [formControlName]="'unit'" [placeholder]="'Unit'" autocorrect="off"
                                    autocapitalize="off" spellcheck="off" type="text" autocomplete="new-password"
                                    #search>
                                <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:location-marker'">
                                </mat-icon>
                            </mat-form-field>
                        </div>
                        <div class="flex">
                            <mat-form-field class="flex-auto">
                                <input matInput [formControlName]="'city'" [placeholder]="'City'" autocorrect="off"
                                    autocapitalize="off" spellcheck="off" type="text" 
                                    
                                    autocomplete="new-password" #search>
                                <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:location-marker'">
                                </mat-icon>
                            </mat-form-field>
                        </div>
                        <div class="flex">
                            <!-- [readonly]="true" -->
                            <mat-form-field class="flex-auto">
                                <input matInput [formControlName]="'province'" [placeholder]="'Province'"
                                    autocorrect="off" autocapitalize="off" spellcheck="off" type="text"
                                     autocomplete="new-password" #search>
                                <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:location-marker'">
                                </mat-icon>
                            </mat-form-field>
                        </div>
                        <div class="flex">
                            <!-- [readonly]="true" -->
                            <mat-form-field class="flex-auto">
                                <input matInput [formControlName]="'country'" [placeholder]="'Country'"
                                    autocorrect="off" autocapitalize="off" spellcheck="off" type="text"
                                     autocomplete="new-password" #search>
                                <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:location-marker'">
                                </mat-icon>
                            </mat-form-field>
                        </div>
                        <div class="flex justify-end mt-8">
                            <button class="px-8 mr-2" mat-flat-button [color]="'accent'" type="button"
                                (click)="gtagEvent('back_step2')" matStepperPrevious>
                                Back
                            </button>
                            <!-- <button
                            class="px-8"
                            mat-flat-button
                            [color]="'primary'"
                            type="button"
                            matStepperNext>
                            Next
                        </button> -->
                            <button class="px-8" mat-flat-button [color]="'primary'" type="submit"
                                (click)="submit(horizontalStepper)">
                                Submit
                            </button>
                        </div>
                    </mat-step>

                    <mat-step>
                        <ng-template matStepLabel>Done</ng-template>
                        <p class="my-6 font-medium">
                            Thank you for completing our form! We will look into the information you provided and get
                            back to you soon.
                        </p>
                        <div class="flex justify-end mt-8">
                            <!-- <button
                            class="px-8 mr-2"
                            mat-flat-button
                            [color]="'accent'"
                            type="button"
                            matStepperPrevious>
                            Back
                        </button> -->
                            <!-- <button
                            class="px-8"
                            mat-flat-button
                            [color]="'primary'"
                            type="reset"
                            (click)="horizontalStepper.reset();">
                            Reset
                        </button> -->
                            <!-- <button
                            class="px-8"
                            mat-flat-button
                            [color]="'primary'"
                            type="submit"
                            (click)="submit()">
                            Submit
                        </button> -->
                        </div>
                    </mat-step>
                </mat-vertical-stepper>
            </form>


        </div>
    </div>
</div>